const chartsData = JSON.parse(document.querySelector('script[data-charts-data]').dataset.chartsData);
let charts = [];
let myChart;
let initialConfig;
let years;
let xAxisTitle;
let datasets;
let dataOrder = { "BWR":3,"PWR":2,"Total":1,"Cumulative Total":1};

// Autoload assemblies first
document.addEventListener('DOMContentLoaded', function() {
    // Load up the assemblies charts first
    // Chart 3 data includes storage location, so if this is our context,
    // then we'll make sure that it loads assemblies/pool data first
    const type = chartsData.some(obj => obj['storage_type'] === 'pool') ? 'assemblies_pool' : 'assemblies';
    renderCharts(type);

    // Add Dropdown listeners for Selection box
    dropDownListeners();

    // Add Toggle listeners for dataset types
    typeToggleListeners();

    // Add year Input Listeners
    yearInputListener();

    // Add reset chart listener
    resetChartListener();

});

// Render charts based on the selected chart type
function renderCharts(chartType, newSelection = null) {
    charts = [];
    datasets = gatherChartData(chartType);

    if (!newSelection) {
        // Setup chart configuration
        setChartConfig(datasets,handleClick);

        // Create chart
        const canvas = document.getElementById('chart');
        const ctx = canvas.getContext('2d');
        myChart = new Chart(ctx, initialConfig);
    }
    else {
        // Check if there are values in 'to' or 'from'
        const fromYearInput = document.getElementById("from").value;
        const toYearInput = document.getElementById("to").value;

        if (fromYearInput || toYearInput) {
            filterAndUpdateChart(parseInt(fromYearInput), parseInt(toYearInput));
        } else {
            myChart.config.data.labels = filterYearsForEveryFiveYears(years);
            myChart.config.data.datasets = filterDataForEveryFiveYears(datasets, years);
            myChart.config.options.scales.x.title.text = xAxisTitle;

            // Update the charts with a new selection
            myChart.update();
        }

        // Re-Add Toggle listeners for dataset types
        typeToggleListeners();

    }


    // Event handler for click event
    function handleClick(event, chartElements) {
        // Checking for if we're asking for a bar chart.
        if (myChart.config.type === 'bar') {
            // Establish the year that has been clicked on and its index, so that we can calculate the data/years around it
            const selectedYear = myChart.config.data.labels[chartElements[0].index];
            const selectedYearIndex = getYearIndex(selectedYear);

            // Calculate the start and end years to display
            const startYearIndex = Math.max(selectedYearIndex - 2, 0);
            const endYearIndex = Math.min(selectedYearIndex + 2, years.length - 1);

            // Get the actual range of years based on the selected year
            const displayRange = getDisplayRange(startYearIndex, endYearIndex);

            // Update chart configuration to display the selected range of years
            myChart.config.data.labels = displayRange;
            let key = document.querySelector('.dropdown-item.active').id;
            myChart.config.data.datasets.forEach(dataset => {
                // Use the full dataset to retrieve the data corresponding to the selected range of years
                const fullDataset = chartsData.find(chart => chart.gen_data === dataset.label && chart.key === key).data;
                dataset.data = filterDataForYears(fullDataset, displayRange);
            });

            // Update the chart
            myChart.update();

            // Update the From and To Years boxes to reflect the clicked values
            document.getElementById("from").value = displayRange.at(-1);
            document.getElementById("to").value = displayRange[0];

            // Show the reset button
            const reset = document.getElementById('reset-chart-button');
            reset.classList.remove('hidden');
        }
    }


}




// Get the actual range of years based on the selected year
function getDisplayRange(startIndex, endIndex) {

    const startYearIndex = Math.max(startIndex, 0);
    const endYearIndex = Math.min(endIndex, years.length - 1);

    // Return the actual range of years
    return years.slice(startYearIndex, endYearIndex + 1);
}

// Filter data based on the selected range of years
function filterDataForYears(data, displayRange) {
    const filteredData = [];
    displayRange.forEach(year => {
        const index = years.indexOf(year);
        if (index !== -1) {
            filteredData.push(data[index]);
        }
    });
    return filteredData;
}

function gatherChartData(chartType) {
    // Filter charts data based on the selected chart type - i.e. assemblies, mtu, etc
    let filteredChartData = chartsData.filter(chart => chart.key === chartType);

    // Initialize arrays to accumulate labels and datasets
    years = filteredChartData[0].labels;
    xAxisTitle = document.getElementById(filteredChartData[0].key).textContent;
    let datasets = [];

    // Loop through filteredChartData array to accumulate data
    filteredChartData.forEach(chartData => {
        datasets.push({
            label: chartData.gen_data,
            data: chartData.data,
            backgroundColor: chartData.data.map(() => getBackgroundColor(chartData.gen_data)),
            borderColor: 'transparent',
            borderWidth: 1,
            order: dataOrder[chartData.gen_data] // Add order property
        });

        renderType(chartData);
    });

    // Sort datasets initially based on the order property
    datasets.sort((a, b) => a.order - b.order);

    return datasets;
}


// Establish chart base configuration
function setChartConfig(datasets, handleClick) {
    // Initial chart configuration
    initialConfig = {
        type: 'bar',
        data: {
            labels: filterYearsForEveryFiveYears(years),
            datasets: filterDataForEveryFiveYears(datasets, years)
        },
        options: {
            onClick: function(event, chartElements) {
                handleClick(event, chartElements); // Ensure to pass parameters
            },
            indexAxis: 'y',
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false
                }
            },
            scales: {
                y: {
                    title: {
                        display: true,
                        text: 'Year'
                    },
                    beginAtZero: true
                },
                x: {
                    title: {
                        display: true,
                        text: xAxisTitle,
                    },
                    beginAtZero: true
                }
            }
        }
    };
}

// Filter years to show every 5 years
function filterYearsForEveryFiveYears(years) {
    return years.filter(year => year % 10 === 0 || year % 10 === 5);
}

// Filter datasets to show data for every 5 years
function filterDataForEveryFiveYears(datasets, filteredYears) {

    let filteredData = datasets.map(dataset => ({
        label: dataset.label,
        data: dataset.data.filter((_, index) => {
            const year = filteredYears[index];
            return year && year % 5 === 0; // Filter every fifth year within the selected range
        }),
        backgroundColor: dataset.backgroundColor,
        borderColor: dataset.borderColor,
        borderWidth: dataset.borderWidth,
        order: dataOrder[dataset.label]
    }));

    return filteredData;
}

// Get index of selected year
function getYearIndex(year) {
    return years.indexOf(year);
}

// Clear existing Types/Checkboxes
function clearType() {
    // Clear Types Container
    let typesContainer = document.getElementById('type-toggle');
    typesContainer.innerHTML = ''; // Clear existing labels
}

// Render Type checkbox labels and colors
function renderType(chartData) {

    // Get the overarching div for these elements
    const typeDiv = document.getElementById('type-toggle');

    // Create the individual div for each toggle
    const toggleDiv = document.createElement('div');

    if (chartData.gen_data.includes('BWR' || '_cumulative_total')) {
        toggleDiv.classList.add('m-1');
    }
    else {
        toggleDiv.classList.add('m-2');
    }

    // Populate labels, checkboxes, and color boxes
    const colorBox = document.createElement('span');
    const input = document.createElement('input');
    const label = document.createElement('label');

    // Give input a class, type, id, and set attribute of checked
    input.classList.add('form-check-input');
    input.setAttribute('type', 'checkbox');
    input.setAttribute('id', 'toggle-'+chartData.gen_data);
    input.setAttribute('checked', 'true');

    // Give the label a class and id and for
    label.classList.add('form-check-label');
    label.setAttribute('id', 'label-'+chartData.gen_data);
    label.setAttribute('for', 'toggle-'+chartData.gen_data);
    label.textContent = chartData.gen_data;

    // Give the colorBox a class
    colorBox.classList.add('color-box');

    // Apply colorBox style - set dynamically with getBackgroundColor()
    colorBox.style.backgroundColor = getBackgroundColor(chartData.gen_data);

    // Set attribute for colorBox
    colorBox.setAttribute('data-label', chartData.gen_data);

    // First, insert toggleDiv inside the typeDiv
    typeDiv.append(toggleDiv);

    // Second, insert input after toggleDiv
    toggleDiv.append(input);

    // Next, insert colorBox after input
    input.insertAdjacentElement('afterend', label);

    // Finally, insert label after colorBox
    label.insertAdjacentElement('afterend', colorBox);

}

// Toggle the visibility of a dataset
function toggleDatasetVisibility(datasetIndex, isVisible) {
    myChart.getDatasetMeta(datasetIndex).hidden = !isVisible;
    myChart.update(); // Update the chart
}

// Set background color based on chart type
function getBackgroundColor(type) {
    switch (type) {
        case 'BWR':
            return '#745FE9';
        case 'PWR':
            return '#1DC2AE';
        case 'Total':
            return '#FA9441';
        case 'Cumulative Total':
            return '#000000';
        default:
            return null;
    }
}

function newSelection (type) {
    const dropdownItems = document.querySelectorAll('.dropdown-item');
    dropdownItems.forEach(item => item.classList.remove('active'));

    let selection = document.getElementById(type);
    selection.classList.add('active');

    updateSelectedItemText()
    clearType();
    renderCharts(type, true);
}

function updateSelectedItemText() {
    document.getElementById('selectedItem').textContent = document.querySelector('.dropdown-item.active').textContent;
}

function dropDownListeners() {

    const dropdownItems = document.querySelectorAll('.dropdown-item');

    dropdownItems.forEach(item => {
        item.addEventListener('click', function () {
            newSelection(this.id)
        });
    });

    // Update selected item text on page load
    updateSelectedItemText();

}

function typeToggleListeners() {
    const checkboxes = document.querySelectorAll('.form-check-input');
    checkboxes.forEach((checkbox) => {
        checkbox.addEventListener('change', function () {
            // Extract chart type from checkbox id
            const chartType = this.id.split('-')[1];
            // Find dataset index by chart type
            const datasetIndex = datasets.findIndex(dataset => dataset.label === chartType);
            if (datasetIndex !== -1) {
                toggleDatasetVisibility(datasetIndex, this.checked);
            }
        });
    });
}

// Event listener for input changes in the year inputs
function yearInputListener() {
    const fromYearInput = document.getElementById("from");
    const toYearInput = document.getElementById("to");
    let typingTimer;

    // Prevent any press of return/enter from reloading the page.
    $(window).keydown(function(event){
        if(event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    });
    function handleInput() {

        clearTimeout(typingTimer);
        typingTimer = setTimeout(function() {
            const fromYearValue = parseInt(fromYearInput.value);
            const toYearValue = parseInt(toYearInput.value);

            if (!isNaN(fromYearValue) && !isNaN(toYearValue)) {
                filterAndUpdateChart(fromYearValue, toYearValue);
            } else if (!isNaN(fromYearValue)) {
                filterAndUpdateChart(fromYearValue, null);
            } else if (!isNaN(toYearValue)) {
                filterAndUpdateChart(null, toYearValue);
            } else {
                // Both inputs are empty
            }
        }, 1000);

        // Show the reset button
        const reset = document.getElementById('reset-chart-button');
        reset.classList.remove('hidden');
    }

    fromYearInput.addEventListener("input", handleInput);
    toYearInput.addEventListener("input", handleInput);
}

// Event listener for the reset chart button
function resetChartListener() {
    const reset = document.getElementById('reset-chart-button');
    reset.addEventListener('click', handleReset);

    reset.addEventListener('keypress', function (event) {
        if (event.key === 'Space') {
            handleReset();
        }
    });

    function handleReset() {
        const type = chartsData.some(obj => obj['storage_type'] === 'pool') ? 'assemblies_pool' : 'assemblies';
        document.getElementById("from").value = '';
        document.getElementById("to").value = '';
        newSelection(type);
        reset.classList.add('hidden');

    }

}

// Filter and update the chart based on the selected range of years
function filterAndUpdateChart(fromYear, toYear) {
    // Filter the years within the specified range
    const filteredYears = years.filter(year => {
        if (fromYear && toYear) {
            return year >= fromYear && year <= toYear;
        } else if (fromYear) {
            return year >= fromYear;
        } else if (toYear) {
            return year <= toYear;
        }
        return true;
    });

    // Determine the number of years to display based on the selected range
    const displayYears = determineDisplayYears(filteredYears);

    // Filter datasets based on the filtered years
    let filteredDatasets = datasets.map(dataset => ({
        label: dataset.label,
        data: dataset.data.filter((_, index) => displayYears.includes(years[index])),
        backgroundColor: dataset.backgroundColor,
        borderColor: dataset.borderColor,
        borderWidth: dataset.borderWidth,
        order: dataOrder[dataset.label] // Add order property
    }));

    // Sort the filteredDatasets based on the order property
    filteredDatasets.sort((a, b) => a.order - b.order);

    // Update chart labels and datasets with the filtered data
    myChart.config.data.labels = displayYears;
    myChart.config.data.datasets = filteredDatasets;
    myChart.config.options.scales.x.title.text = xAxisTitle;

    // Update chart
    myChart.update();
}


function determineDisplayYears(filteredYears) {
    const numYears = filteredYears.length;
    if (numYears <= 10) {
        // Display all years if there are 10 or fewer years
        return filteredYears;
    } else {
        // Determine the step size for displaying years
        const stepSize = Math.ceil(numYears / 10);
        // Filter years to display every stepSize years
        return filteredYears.filter((year, index) => index % stepSize === 0);
    }
}
